import { Info } from 'lucide-react';
import { useState } from 'react';

/**
 * Retour 13 (recette 4L, 00252) : infobulle « i » sur le numéro de CEAM — les
 * participants saisissent souvent leur n° de sécurité sociale à la place du
 * numéro de carte. L'image d'exemple (`/documents/ceam-exemple.png`) est
 * fournie par l'équipe 4L ; tant qu'elle n'est pas déposée, le texte suffit.
 */
export function BedCeamHint() {
  const [open, setOpen] = useState(false);
  return (
    <div className="text-xs text-zinc-600">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
        className="inline-flex items-center gap-1 text-zinc-700 underline decoration-dotted underline-offset-2 hover:text-zinc-900"
        title="Où trouver le numéro de ma carte européenne d’assurance maladie ?"
      >
        <Info className="h-3.5 w-3.5" aria-hidden="true" />
        Où trouver ce numéro ?
      </button>
      {open && (
        <div className="mt-2 space-y-2 rounded-md border border-zinc-200 bg-zinc-50 p-3">
          <p>
            Il s’agit du <strong>numéro d’identification de la carte</strong> (ligne 8 sur la carte
            européenne), <strong>pas</strong> de votre numéro de sécurité sociale. Il figure en bas
            de la carte, ou sur l’attestation provisoire reçue d’Ameli.
          </p>
          <img
            src="/documents/ceam-exemple.png"
            alt="Exemple de carte européenne d’assurance maladie — le numéro à saisir est en bas de la carte"
            className="max-h-48 rounded border border-zinc-200 bg-white"
            onError={(event) => {
              (event.currentTarget as HTMLImageElement).style.display = 'none';
            }}
          />
        </div>
      )}
    </div>
  );
}
